module.exports = __webpack_public_path__ + "languageicon-6b605a04.png";